import { Alert } from '@vtex/shoreline'

import { formatMoney, getDurationInDays } from '~/helpers'
import { useAPPTranslation } from '~/i18n/useAPPTranslation'

import styles from './styles.module.css'

type BudgetPacingNoticeProps = {
  dailyAllocation?: number | null
  startDate?: string | null
  endDate?: string | null
  dataTestId?: string
}

const BudgetPacingNotice: React.FC<BudgetPacingNoticeProps> = ({
  dailyAllocation,
  startDate,
  endDate,
  dataTestId = 'budget-pacing-notice'
}) => {
  const { t } = useAPPTranslation()

  const hasEndDate = !!endDate
  const hasDaily = !!dailyAllocation && dailyAllocation > 0

  if (!hasDaily) return null

  const duration =
    startDate && endDate
      ? (getDurationInDays({
          startDate,
          endDate,
          returnType: 'number'
        }) as number)
      : null

  const valueLabel =
    hasEndDate && hasDaily && duration
      ? formatMoney(dailyAllocation * duration)
      : t('rm:campaign.create.Investment.pacing.infinite')

  const allocationLabel = t(
    'rm:campaign.create.Investment.pacing.formula.allocationLabel'
  )
  const durationLabel = t(
    'rm:campaign.create.Investment.pacing.formula.durationLabel'
  )
  const multiplier = t(
    'rm:campaign.create.Investment.pacing.formula.multiplier'
  )
  const daysText = hasEndDate && duration ? String(duration) : '∞'

  return (
    <div className={styles.root} data-testid={dataTestId}>
      <Alert variant="informational">
        {t('rm:campaign.create.Investment.pacing.info')}
      </Alert>
      {!hasEndDate && (
        <Alert variant="informational">
          {t('rm:campaign.create.Investment.pacing.noEndDate')}
        </Alert>
      )}
      <div className={styles.box}>
        <span className={styles.title}>
          {t('rm:campaign.create.Investment.pacing.title')}
        </span>
        <span className={styles.value}>{valueLabel}</span>
        <div className={styles.formulaRow}>
          <span>=</span>
          <span>{formatMoney(dailyAllocation)}</span>
          <span className={styles.muted}>{allocationLabel}</span>
          <span>
            {multiplier} {daysText}
          </span>
          <span className={styles.muted}>{durationLabel}</span>
        </div>
      </div>
    </div>
  )
}

export default BudgetPacingNotice
